import { Adapter } from '../adapters/Adapter';
import { Site } from './Site';
import { BehaviorSubject } from 'rxjs';
import { Entity } from './Entity';


export class Customer implements Entity{
  public sites: Site[];
  public ready = new BehaviorSubject<boolean>(false);
  isFavorite = false;
  expanded = false;
  constructor(
    public id: number,
    public company: string,
    public city: string,
    public country: string
  ) {

  }

  getId() {
    return this.id;
  }

  getType(): 'customer' | 'site' | 'train' {
    return 'customer';
  }

  getName() {
    return this.company;
  }
}

export class CustomerAdapter implements Adapter<Customer> {
  public adapt(item: any): Customer {
    if (item.company === undefined || item.company === null) {
      item.company = '-';
    }
    return new Customer(item.id, item.company, item.city, item.country);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Customer.ts